import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const ThumbsUp = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M2 20.4512H4C4.55 20.4512 5 20.0012 5 19.4512V10.4512C5 9.90117 4.55 9.45117 4 9.45117H2V20.4512ZM21.83 13.3312C21.94 13.0812 22 12.8112 22 12.5312V11.4512C22 10.3512 21.1 9.45117 20 9.45117H14.5L15.42 4.80117C15.47 4.58117 15.44 4.34117 15.34 4.14117C15.11 3.69117 14.82 3.28117 14.46 2.92117L14 2.45117L7.59 8.86117C7.21 9.24117 7 9.75117 7 10.2812V18.1212C7 19.4012 8.05 20.4512 9.34 20.4512H17.45C18.15 20.4512 18.81 20.0812 19.17 19.4812L21.83 13.3312Z"
    />
  </svg>
);
